import { HostBinding,Renderer2,HostListener,AfterViewChecked,ChangeDetectorRef,ElementRef,ViewChild,ViewChildren,QueryList,Component, OnInit, OnChanges, OnDestroy ,SimpleChanges, AfterViewInit,ViewEncapsulation} from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {NewsletterService} from '../../services/newsletter.service';
import {IRule} from '../../irule';
import{TemplateService} from '../../services/template.service';
import{ArticleService} from '../../services/article.service';
import { ThrowStmt } from '@angular/compiler';

declare var $:any;


@Component({
  selector: 'app-template-list',
  templateUrl: './template-list.component.html',
  styleUrls: ['./template-list.component.css']
})

export class TemplateListComponent extends BaseComponent implements OnInit,AfterViewInit,IRule {

  @HostBinding('style.width') public width: string = '100%';

  templateId:number=0;

  dropdownSettings={}
  templateGroupList:any =[];
  selectedGroup:any=[];

  templateList:any=[];

  loader_image:boolean = true;

  record_empty:number =0;

  record_offset:number = 0;

  per_page:number = 10;

  selectedMobOrder:any


  orderList=[
    {key:'createdDate',value:'Created Date'},
    {key:'updatedDate',value:'Updated Date'}
  ]

  isDescToggle:boolean=true;
  isSelectDesc = ' desc';
   msg:any;
   toastr:any;
   homeservice:any;
   _router:any;
   token:any;
   search:any='';
   selectedOrder:any=[];
   userName='';
   navigationsType=[];
   notification:any=[];

   paramsgroup:any;

  constructor( private ref:ChangeDetectorRef,homeservice:HomeService,_router: Router,private newsService:NewsletterService , toastr: ToastrService,private renderer: Renderer2, msg:MessageService,private templateService:TemplateService , private articleService:ArticleService,private route:ActivatedRoute){

    super(msg,toastr,homeservice,_router);

    this.route.queryParams.subscribe(params =>{
      if(params.group!=undefined){
        this.paramsgroup = params.group
      }
    })

    try{


      this.msg = msg;
      this.toastr = toastr;
      this.homeservice = homeservice;
      this._router =_router;

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);

      this.token = tokenA.token;

      let data={
        token:tokenA.token,
        group:''
      }



      this.articleService.getTemplateGroup(data).subscribe( (elem)=>{

        this.userName=elem.user.name;

        this.navigationsType=elem.navigation;

        this.notification = elem.notification;

        this.broadcast_menu();

        if(elem.status =='success'){

          elem.group.map((x)=>{
            let string = x.value
            x.value = string.charAt(0).toUpperCase() + string.slice(1)
          })

           this.templateGroupList = elem.group;

           if(this.paramsgroup!=undefined){

              let type = this.paramsgroup

              let typestr = this.templateGroupList.find( (item) =>{ return item.key == type;});

              let arr =[]
              arr.push(typestr)
              this.selectedGroup = arr

              this.searchList(0);

           }


        }

      });



    }catch(exec){

    }


  }


  sortDesc(){

     this.isDescToggle = false;
     this.isSelectDesc = ' asc';
     this.templateList=[];
     this.searchList(0)

   }

   sortAsc(){

     this.isDescToggle = true;
     this.isSelectDesc = ' desc';
     this.templateList=[];
     this.searchList(0)

   }

   onItemSelect(item: any) {

    this.templateList=[]
    this.searchList(0)

  }

  onItemDeSelect(item:any){

    this.templateList=[];
    this.searchList(0)

  }

  template_remove(id:number){

    this.templateId =id;

    $('#success-popup').modal('show');


  }


  deleteTemplate(){



    let data={
      token:this.token,
      reqData:{
        id:this.templateId,
        archive:true,
        'page':'template'
      }

      //offset:this.record_offset
    }


    this.articleService.removeTemplate(data).subscribe( (res)=>{



      if(res.status=='success'){

        let catI = this.templateList.findIndex( (elm) => { return  elm.id ==  this.templateId});


        this.templateList.splice(catI,1);

        this.templateId =0;


      }else{
        this.templateId =0;
      }

    });


  }

   searchList(offset:number){





    this.record_empty =1 ;

    this.loader_image =true;


    this.record_offset = offset;


    let data={};

    if(this.selectedOrder[0]!=undefined && this.selectedOrder[0].key == 'createdDate'){

      data['order'] = 'createdon' +this.isSelectDesc;

    }else if(this.selectedOrder[0]!=undefined && this.selectedOrder[0].key == 'updatedDate'){

      data['order'] = 'updatedon'+this.isSelectDesc;

    }else{

      data['order'] = 'updatedon' +this.isSelectDesc;
    }



    if(this.selectedGroup[0]!=undefined){

      data['group'] = this.selectedGroup[0].key
    }


    // if(this.paramsgroup!=undefined){

    //   data['group'] =this.paramsgroup;

    // }




    if(this.search!=undefined){

      data['search'] = this.search

    }


    data['limit'] = this.per_page;

    data['offset'] =this.record_offset;

    data['page']='template';


    let data2={
      token:this.token,
      details: data
    }





    this.templateService.getTemplateList(data2).subscribe( (elem)=>{






      if(elem.status =='success'){


        if( elem.template.length > 0) {

          this.record_empty =0 ;

          this.loader_image =false;


          if(this.templateList.length ==0 ){


            this.templateList = elem.template;

            if (!this.ref['destroyed']) {
              this.ref.detectChanges();
            }



          } else{



            if(this.record_offset == 0){

              this.templateList = elem.template;

            } else {


              elem.template.forEach(element => {

                this.templateList.push(element);

              });


            }




            if (!this.ref['destroyed']) {
              this.ref.detectChanges();
            }

          }




        } else{






          this.record_empty =1 ;

          this.loader_image =false;

          if(this.record_offset !=0){

           // this.record_offset-=this.per_page;

          } else{

            this.templateList = elem.template;

          }




        }





      } else{

        this.loader_image =false;

        this._router.navigate(['/login']);


      }

    });



   }

  ngOnInit() {


    window.scrollTo(0,0);


    this.dropdownSettings = {
      singleSelection: true,
      idField: 'key',
      textField: 'value',
      closeDropDownOnSelection:true
    };

    this.searchList(0);

  }

  ngAfterViewInit(){

    $(function(){

    })

    $(window).on("scroll", function() {



      if(this._router.url == '/template' || (this._router.url.indexOf('template?group')>=0)){





        if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {




           if(this.record_empty == 0){

              this.record_empty =1;

              this.record_offset+=this.per_page;

              this.searchList(this.record_offset);

            }


        }




      }





    }.bind(this));



  }

  broadcast_menu(){

    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType});
   }

   hideDiv(id:any){



    $('#'+id).hide();
    $('.modal_backdrop_bg').hide();
  }

  onChangeMob(event){

    if(event.target.value == 'descending'){
      this.isSelectDesc = ' asc';
    }else{
      this.isSelectDesc = ' desc';
    }

    this.templateList=[];
    this.searchList(0)
  }

  get_group(type:string){

    if(type!=undefined || type!=null){
      let typestr = this.templateGroupList.find( (item) =>{ return item.key == type;});
      return (typestr!=undefined)?typestr.value:'';
    }else{
      return '';
    }
  }

}
